<!-- =========================================================================================
    File Name: Register.vue
    Description: Register Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div id="RegisterBody" class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center overflow-y-auto py-4">
<!--    <img v-if="!isMobile" :src="loginTopImage" style="position: absolute; left: 60px; top: 48px; width: 100%; max-width: 180px;" alt="" class="xl" />-->

    <div style="width: 640px; max-width: 90%" >
      <privacy-consent v-if="step === 약관페이지" @close="onClickClose" @prev="onClickPrev" @next="onClickNext"/>
      <register-type v-if="step === 타입페이지" @close="onClickClose" @prev="onClickPrev" @next="onClickNext" v-model="registerType"/>
      <register-form v-if="step === 가입폼페이지" ref="registerForm" @close="onClickClose" @prev="onClickPrev" @next="onClickNext" :register="register" :register-type="registerType"/>
      <register-success v-if="step === 완료페이지" @close="onClickClose" :account="register.accountInput" :name="register.name"/>
    </div>
  </div>
</template>

<script>

import PrivacyConsent from "@/views/pages/register/PrivacyConsent.vue";
import RegisterForm from "@/views/pages/register/RegisterForm.vue";
import RegisterSuccess from "@/views/pages/register/RegisterSuccess.vue";
import HttpRequest from "@/util/HttpRequest";
import RegisterType from "@/views/pages/register/RegisterType.vue";
import * as UiUtil from "@/util/UiUtil";

export default {
  components: {
    RegisterType,
    RegisterSuccess,
    RegisterForm,
    PrivacyConsent
  },
  computed: {
    isMobile() {
      return this.$viewport.width < 768;
    },

    약관페이지() { return 0 },
    타입페이지() { return 1 },
    가입폼페이지() { return 2 },
    완료페이지() { return 3 },
  },
  data () {
    return {
      loginTopImage: require('@/assets/images/pages/shm_logo_Login.svg'),
      step: 0,

      // 가입 데이터
      register: {
        accountInput: '', // 아이디
        passwordInput: '', // 비밀번호
        foreign: false, // 내국인/외국인
        name: '', // 이름
        rrn: '', // 주민등록번호
        phone: '', // 휴대폰번호
        verifiedPhone: '', // 휴대폰번호 인증여부
        email: '', // 이메일
        address: {
          home_zip: '',
          home_address_1: '',
          home_address_2: '',
        }, // 주소
        직종: '', // 직종
        직종_직접입력: '',
        field: {}, // 사업장
        업체: {}, // 업체
        건설업기초안전교육: '',
        장비운전자: false,
        건설기계조종사면허번호: '',
        건설기계조종사면허증사진: '',
        장비명: '직접입력',
        장비명_직접입력: '',
        장비규격: '',
        장비규격_직접입력: '',
        장비번호: '',
      },
      registerType: '원청사근로자',
    }
  },
  created() {
    this.loadLoginTopImage().then();
  },
  methods:{

    /**
     * 로그인 화면에서 상단에 표시되는 이미지를 불러온다
     */
    async loadLoginTopImage() {
      // 로컬 스토리지에 `${host_name}_login_left_image` 키로 저장된 이미지가 있는지 확인한다.
      // 있으면 그 이미지를 사용하고, 없으면 서버에서 이미지를 가져와서 로컬 스토리지에 저장한다.
      if (localStorage.getItem(`${this.hostname}_login_top_image`)) {
        this.loginTopImage = localStorage.getItem(`${this.hostname}_login_top_image`);
      }

      const config = await this.$store.dispatch("keyValue/LOAD_CONFIG", {
        key: "login_top_image",
      });

      if (config && config.path) {
        // 로컬 스토리지에 저장한다
        localStorage.setItem(`${this.hostname}_login_top_image`, config.path);

        this.loginTopImage = config.path;
      }
    },
    onClickClose() {
      this.$router.push('/login');
    },
    onClickPrev() {
      document.getElementById('RegisterBody').scrollTop = 0;
      if (this.step === 0) {
        this.$router.push('/login');
      }
      this.step--;
    },
    async onClickNext() {
      // 가입신청
      if (this.step === this.가입폼페이지) {

        UiUtil.loading(true)
        const isPendingAccountSuccess = await this.pendingAccount();
        UiUtil.loading(false)
        if (!isPendingAccountSuccess) {
          return;
        }
      }

      document.getElementById('RegisterBody').scrollTop = 0;
      this.step++;
    },

    async pendingAccount() {
      const meta = JSON.stringify({
        address: this.register.address,
        직종: this.register.직종,
        직종_직접입력: this.register.직종_직접입력,
        field: this.register.field,
        // 업체: this.register.업체,
        건설업기초안전교육: this.register.건설업기초안전교육,
        장비운전자: this.register.장비운전자,
        건설기계조종사면허번호: this.register.건설기계조종사면허번호,
        enc: {
          건설기계조종사면허증사진: this.register.건설기계조종사면허증사진,
        },
        장비명: this.register.장비명,
        장비명_직접입력: this.register.장비명_직접입력,
        장비규격: this.register.장비규격,
        장비규격_직접입력: this.register.장비규격_직접입력,
        장비번호: this.register.장비번호,
        registerType: this.registerType,
      })

      const response = await HttpRequest.post('/api/v1/user/register', {
        username: this.register.accountInput,
        password: this.register.passwordInput,
        name: this.register.name,
        rrn: this.register.rrn,
        phone: this.register.phone,
        phoneCode: this.register.verifiedPhone,
        email: this.register.email,
        isForeign: this.register.foreign,
        bnum: this.register.업체.com_number,
        meta: meta,
        ...(this.register.email && { email: this.register.email })
      }).catch(err => {
        console.log("err", err);
        if (err.response && err.response.data) {
          Object.keys(err.response.data).forEach(key => {
            if (Array.isArray(err.response.data[key])) {
              const errorMessages = err.response.data[key].join(', ');
              this.customAlert(errorMessages);
            } else {
              this.customAlert(err.response.data[key]);

              // 이전에 받은 휴대폰 인증성공표시 제거
              if (err.response.data[key].includes('휴대폰 인증 코드가 만료되었습니다') && this.$refs.registerForm) {
                this.$refs.registerForm.confirmPhoneAuth = false
              }
            }
          });
        } else {
          this.customAlert("알수 없는 오류가 발생했습니다");
        }

        return false;
      });

      if (response && response.success) {
        return true;
      }

      return false;
    },
    customAlert(msg) {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "오류가 발생했습니다",
          message: msg,
          cancelBtn: "확인",
        },
      });
      window.dispatchEvent(customAlert);
    },
  }
}
</script>

<style lang="scss">
.register-tabs-container {
  min-height: 517px;

  .con-tab {
    padding-bottom: 23px;
  }
}
</style>
